function ProductCard(container) {
  const variantSelector = container.querySelector('[data-product-select]');
  const addToCartButton = container.querySelector('.product-card__add');
  let selectedVariantId;
  if (variantSelector) {
    selectedVariantId = variantSelector.options[variantSelector.selectedIndex].value;
    variantSelector.addEventListener('change', () => {
      selectedVariantId = variantSelector.options[variantSelector.selectedIndex].value;
      if (addToCartButton && variantSelector.options[variantSelector.selectedIndex].disabled) {
        addToCartButton.setAttribute('disabled', 'disabled');
      } else {
        addToCartButton.removeAttribute('disabled');
      }
    });
  }

  container.addEventListener(
    'click',
    function (evt) {
      const target = evt.target;
      if (variantSelector) {
        if (target.matches('[data-add-to-cart]')) {
          evt.preventDefault();
          const addedLabel = container.querySelector('.product-card__added');
          window.sideCart.handleAddToCartEvent(evt, selectedVariantId, 1, true);
          addedLabel.classList.add('show');
          setTimeout(() => {
            addedLabel.classList.remove('show');
          }, 2000);
        }
      }
      if (target.closest('.ruk_rating_snippet')) {
        evt.preventDefault();
        evt.stopPropagation();
        const url = target.closest('.ruk_rating_snippet').dataset.reviewsUrl;
        window.location = url;
      }
    },
    {capture: true}
  );
}

export default ProductCard;
